import { jsx, jsxs } from 'react/jsx-runtime';
import styled, { useTheme } from 'styled-components';

/* eslint-disable react/destructuring-assignment */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Svg = styled.svg(_templateObject());
// default size: 22x22
var CheckmarkIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 22 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 22 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        "aria-label": "checkbox",
        height: height,
        viewBox: "0 0 22 22",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: "1",
            children: /*#__PURE__*/ jsx("polyline", {
                points: "6.28780897 10.7343281 9.88645522 14.3329744 16.1527629 8.06666667",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        })
    }));
};
// default size: 20x20
var CircledCheckmarkIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 22 22",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: "10",
                cy: "10",
                r: "8.5",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                "stroke-width": "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M6.5 10.5L8.80466 12.8047C8.90925 12.9092 9.08127 12.9007 9.17493 12.7862L13.5 7.5",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                "stroke-linecap": "round",
                "stroke-width": "2"
            })
        ]
    }));
};
// default size: 18x18
var CircledPinkCheckmarkIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 18 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 18 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 18 18",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: "9.00098",
                cy: "9",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.pink,
                r: "9"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M6.25464 9.22014L8.40888 11.4811L12.16 7.54413",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var HamburgerIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M2 4H18",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M2 10H18",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M2 16H18",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 30x30
var DeleteIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 30 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 30 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 30 30",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M11.4645 18.5355L18.5355 11.4645",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.metal,
                strokeLinecap: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M18.5356 18.5355L11.4645 11.4645",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.metal,
                strokeLinecap: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 22x42
var ThinBigLeftChevronIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 42 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 22 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 22 42",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M20.5867 1.82664L1.41333 21L20.5867 40.1733",
            fill: "transparent",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.solidGray,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    }));
};
// default size: 22x42
var ThinBigRightChevronIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 42 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 22 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 22 42",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M1.4133 1.82664L20.5867 21L1.4133 40.1733",
            fill: "transparent",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.solidGray,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    }));
};
// default size: 20x20
var ThinSmallLeftChevronIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 30 30",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M13.3826 3.67149L6.61731 10.2259L13.3826 16.3285",
            fill: "transparent",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
// default size: 20x20
var FatSmallLeftChevronIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M13.3826 3.17149L6.61731 10.2438L13.3826 16.8285",
            fill: "transparent",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    }));
};
// default size: 20x20
var FatSmallBottomChevronIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M3.17151 6.61734L10.2438 13.3827L16.8285 6.61734",
            fill: "transparent",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    }));
};
// default size: 30x30
var PhoneIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 30 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 30 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 30 30",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M11.1335 14.365C11.1335 14.365 15.9482 12.0001 12.8937 5.93189C9.83916 -0.136332 5.59965 2.94479 4.43556 4.05464C3.27146 5.16449 0.918137 7.59543 4.43556 14.6832C7.95298 21.7711 14.1424 26.239 19.9024 27.5365C25.6624 28.834 29.1063 22.807 26.5791 19.6334C24.1204 16.546 19.8397 13.8948 16.8115 17.7666",
                fill: "transparent",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M9.4935 12.6178C9.4935 12.6178 12.3385 17.8133 17.7173 21.0421",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.white,
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 8x6
var BottomSmallArrowIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 8 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 6 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 8 6",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            clipRule: "evenodd",
            d: "M0.314694 1.32868C0.0518829 0.873479 0.380472 0.3044 0.906095 0.3044L7.09397 0.3044C7.61959 0.3044 7.94808 0.873479 7.68527 1.32868L4.59138 5.3542C4.32857 5.8094 3.67149 5.8094 3.40868 5.3542L0.314694 1.32868Z",
            fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            fillRule: "evenodd"
        })
    }));
};
// default size: 12x10
var BottomLargeArrowIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 12 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 10 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 12 10",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            clipRule: "evenodd",
            d: "M0.472074 2.49302C0.0778562 1.81022 0.570739 0.956596 1.35917 0.956596L10.641 0.956596C11.4294 0.956596 11.9222 1.81022 11.5279 2.49302L6.8871 8.53129C6.49289 9.2141 5.50727 9.2141 5.11305 8.53129L0.472074 2.49302Z",
            fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            fillRule: "evenodd"
        })
    }));
};
// default size: 20x20
var HelpIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: "10",
                cy: "10",
                r: "8.5",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M7.728 6.556C7.876 6.432 8.036 6.316 8.208 6.208C8.384 6.1 8.572 6.006 8.772 5.926C8.972 5.842 9.186 5.778 9.414 5.734C9.646 5.686 9.896 5.662 10.164 5.662C10.54 5.662 10.878 5.712 11.178 5.812C11.482 5.912 11.74 6.056 11.952 6.244C12.164 6.428 12.326 6.652 12.438 6.916C12.554 7.176 12.612 7.466 12.612 7.786C12.612 8.094 12.57 8.358 12.486 8.578C12.402 8.798 12.294 8.99 12.162 9.154C12.034 9.318 11.892 9.46 11.736 9.58C11.584 9.696 11.438 9.806 11.298 9.91C11.162 10.014 11.042 10.116 10.938 10.216C10.838 10.316 10.776 10.428 10.752 10.552L10.584 11.392H9.312L9.18 10.426C9.176 10.402 9.172 10.378 9.168 10.354C9.168 10.33 9.168 10.306 9.168 10.282C9.168 10.106 9.21 9.952 9.294 9.82C9.378 9.688 9.484 9.568 9.612 9.46C9.74 9.348 9.878 9.242 10.026 9.142C10.174 9.038 10.312 8.928 10.44 8.812C10.568 8.692 10.674 8.56 10.758 8.416C10.842 8.268 10.884 8.094 10.884 7.894C10.884 7.654 10.804 7.464 10.644 7.324C10.488 7.18 10.272 7.108 9.996 7.108C9.784 7.108 9.606 7.13 9.462 7.174C9.322 7.218 9.2 7.268 9.096 7.324C8.996 7.376 8.908 7.424 8.832 7.468C8.756 7.512 8.68 7.534 8.604 7.534C8.432 7.534 8.304 7.46 8.22 7.312L7.728 6.556ZM8.832 13.558C8.832 13.414 8.858 13.28 8.91 13.156C8.966 13.032 9.04 12.924 9.132 12.832C9.228 12.74 9.34 12.668 9.468 12.616C9.596 12.56 9.736 12.532 9.888 12.532C10.036 12.532 10.174 12.56 10.302 12.616C10.43 12.668 10.542 12.74 10.638 12.832C10.734 12.924 10.808 13.032 10.86 13.156C10.916 13.28 10.944 13.414 10.944 13.558C10.944 13.702 10.916 13.838 10.86 13.966C10.808 14.09 10.734 14.198 10.638 14.29C10.542 14.382 10.43 14.454 10.302 14.506C10.174 14.558 10.036 14.584 9.888 14.584C9.736 14.584 9.596 14.558 9.468 14.506C9.34 14.454 9.228 14.382 9.132 14.29C9.04 14.198 8.966 14.09 8.91 13.966C8.858 13.838 8.832 13.702 8.832 13.558Z",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night
            })
        ]
    }));
};
// default size: 20x20
var RefreshIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M3.73617 6.17782C5.79966 2.60375 10.4362 1.41776 14.0926 3.52875C17.7489 5.63974 19.0401 10.2481 16.9766 13.8222C14.9131 17.3963 10.2765 18.5822 6.6202 16.4713",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M1.75011 5.03115L5.72223 7.32446L2.2417 8.76631L1.75011 5.03115V5.03115Z",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                fillRule: "evenodd",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var CreditCardIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M16.6559 16H3.34491C2.05545 16 1 14.8951 1 13.5443V6.45571C1 5.10486 2.05545 4 3.34491 4H16.6559C17.9454 4 19 5.10486 19 6.45571V13.5443C19 14.8951 17.9454 16 16.6559 16V16Z",
                fillRule: "evenodd",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M1.0004 8H18.0004",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var CalendarIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M4 4.75H16C17.6569 4.75 19 6.09315 19 7.75V14.75C19 16.4069 17.6569 17.75 16 17.75H4C2.34315 17.75 1 16.4069 1 14.75V7.75C1 6.09315 2.34315 4.75 4 4.75Z",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M1.98831 13.75H17.7778",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M5.55555 2.05V4.45",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.4444 2.05V4.45",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var LockIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M1 10C1 8.34315 2.34315 7 4 7H16C17.6569 7 19 8.34315 19 10V16C19 17.6569 17.6569 19 16 19H4C2.34315 19 1 17.6569 1 16V10Z",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15.125 7V6.125C15.125 3.29454 12.8305 1 10 1V1C7.16954 1 4.875 3.29454 4.875 6.125V7",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var CakeIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M1 7.9V15.9C1 17.557 5.029 18.9 10 18.9C14.971 18.9 19 17.557 19 15.9V7.9",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M1 7.9C1 6.243 5.029 4.9 10 4.9C14.971 4.9 19 6.243 19 7.9",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M5 6.9V1.1",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M10 7.9V2.1",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15 6.9V1.1",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M1.16669 9.1083C1.16669 9.1083 1.12469 11.3373 3.24969 11.5873C5.37469 11.8373 6.62469 10.5253 6.62469 10.5253C6.62469 10.5253 8.06269 12.2753 10.4377 12.2123C12.8127 12.1503 13.8747 10.2753 13.8747 10.2753C13.8747 10.2753 14.8127 11.6503 16.4377 11.5873C18.0627 11.5253 18.8127 9.4623 18.8127 9.4623",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var EnvelopeIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M16.4215 16.5H3.5794C2.161 16.5 1 15.3031 1 13.8396V6.16036C1 4.69693 2.161 3.5 3.5794 3.5H16.4215C17.8399 3.5 19 4.69693 19 6.16036V13.8396C19 15.3031 17.8399 16.5 16.4215 16.5V16.5Z",
                fillRule: "evenodd",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M1.0004 7.5L10.0004 10.5L19.0004 7.5",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var PrivateIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M6.00438 6.14398C4.80475 6.7444 3.19985 8.02974 1.18967 10C3.81934 13.155 6.75612 14.7325 9.99999 14.7325C13.2439 14.7325 16.1806 13.155 18.8103 10C16.1806 6.84498 13.2439 5.26747 9.99999 5.26747",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("ellipse", {
                cx: "9.99998",
                cy: "9.99999",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                rx: "2.93677",
                ry: "2.83952"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M3.14752 2.9012L17.8314 17.0988",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
// default size: 20x20
var NonPrivateIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M6.00438 6.14398C4.80475 6.7444 3.19985 8.02974 1.18967 10C3.81934 13.155 6.75612 14.7325 9.99999 14.7325C13.2439 14.7325 16.1806 13.155 18.8103 10C16.1806 6.84498 13.2439 5.26747 9.99999 5.26747",
                fillRule: "evenodd",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("ellipse", {
                cx: "9.99998",
                cy: "9.99999",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                rx: "2.93677",
                ry: "2.83952"
            })
        ]
    }));
};
// default size: 20x20
var SearchIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            clipRule: "evenodd",
            d: "M17.7721 15.9316L14.092 12.2517C13.7952 11.9548 13.3184 11.9497 13.0124 12.2313L12.1453 11.3642C12.9606 10.3751 13.4506 9.10752 13.4506 7.72514C13.4506 4.56382 10.8868 2 7.72527 2C4.56376 2 1.99997 4.56372 1.99997 7.72514C1.99997 10.8866 4.56376 13.4503 7.72527 13.4503C9.1078 13.4503 10.3756 12.9603 11.3645 12.145L12.2316 13.0121C11.949 13.3181 11.9551 13.7949 12.2509 14.0917L15.932 17.7717C16.236 18.0766 16.7331 18.0756 17.036 17.7717L17.772 17.0357C18.076 16.7307 18.076 16.2356 17.7721 15.9316ZM7.72548 11.8889C5.42601 11.8889 3.56162 10.0246 3.56162 7.72517C3.56162 5.42577 5.42601 3.56143 7.72548 3.56143C10.0249 3.56143 11.8893 5.42577 11.8893 7.72517C11.8893 10.0246 10.0249 11.8889 7.72548 11.8889Z",
            fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            fillRule: "evenodd"
        })
    }));
};
// default size: 20x22
var LocationIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 22 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("mask", {
                height: "20",
                id: "mask0_104_1164",
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: "alpha"
                },
                width: "14",
                x: "3",
                y: "1",
                children: /*#__PURE__*/ jsx("path", {
                    clipRule: "evenodd",
                    d: "M3.41943 8.5111C3.41943 15.1491 10.0004 20.1281 10.0004 20.1281C10.0004 20.1281 16.5804 15.1491 16.5804 8.5111C16.5804 4.8441 13.6344 1.8721 10.0004 1.8721C6.36543 1.8721 3.41943 4.8441 3.41943 8.5111V8.5111Z",
                    fill: "white",
                    fillRule: "evenodd"
                })
            }),
            /*#__PURE__*/ jsxs("g", {
                mask: "url(#mask0_104_1164)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        clipRule: "evenodd",
                        d: "M1.29645 22.2511H18.7034V-0.2509H1.29645V22.2511Z",
                        fillRule: "evenodd",
                        stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        clipRule: "evenodd",
                        d: "M3.41943 20.1281H16.5804V1.8721H3.41943V20.1281Z",
                        fillRule: "evenodd",
                        stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M16.5806 8.5109C16.5806 15.1499 9.99956 20.1279 9.99956 20.1279C9.99956 20.1279 3.41956 15.1499 3.41956 8.5109C3.41956 4.8449 6.36556 1.8719 9.99956 1.8719C13.6346 1.8719 16.5806 4.8449 16.5806 8.5109",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M13.2902 8.5109C13.2902 10.3439 11.8172 11.8299 10.0002 11.8299C8.18223 11.8299 6.70923 10.3439 6.70923 8.5109C6.70923 6.6779 8.18223 5.1919 10.0002 5.1919C11.8172 5.1919 13.2902 6.6779 13.2902 8.5109",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("mask", {
                height: "7",
                id: "mask1_104_1164",
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: "alpha"
                },
                width: "8",
                x: "6",
                y: "5",
                children: /*#__PURE__*/ jsx("path", {
                    clipRule: "evenodd",
                    d: "M6.70941 8.5111C6.70941 10.3441 8.18241 11.8301 10.0004 11.8301C11.8174 11.8301 13.2904 10.3441 13.2904 8.5111C13.2904 6.6771 11.8174 5.1921 10.0004 5.1921C8.18241 5.1921 6.70941 6.6771 6.70941 8.5111V8.5111Z",
                    fill: "white",
                    fillRule: "evenodd"
                })
            }),
            /*#__PURE__*/ jsxs("g", {
                mask: "url(#mask1_104_1164)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        clipRule: "evenodd",
                        d: "M3.41943 20.1281H16.5804V1.8721H3.41943V20.1281Z",
                        fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                        fillRule: "evenodd"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        clipRule: "evenodd",
                        d: "M4.58643 13.9531H15.4124V3.0691H4.58643V13.9531Z",
                        fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
                        fillRule: "evenodd"
                    })
                ]
            })
        ]
    }));
};
var CloseIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M4 16L16 3.99998",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.white,
                strokeLinecap: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15.9999 16L3.99995 3.99998",
                stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.white,
                strokeLinecap: "round",
                strokeWidth: "2"
            })
        ]
    }));
};
var BackIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 13 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 14 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 14 13",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            children: /*#__PURE__*/ jsx("path", {
                d: "M6.722 11.223 1.944 6.444l4.778-4.778M12.5 6.5H2.964"
            })
        })
    }));
};
var DownloadIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 18 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 20 18",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("g", {
            fill: "transparent",
            fillRule: "evenodd",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.primary,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            children: /*#__PURE__*/ jsx("path", {
                d: "M19 12v5H1v-5h0M14.723 6.778l-4.779 4.778-4.778-4.778M10 1v9.536"
            })
        })
    }));
};
var MoreIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 5 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 21 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 21 5",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsxs("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeWidth: "2.4",
            children: [
                /*#__PURE__*/ jsx("circle", {
                    cx: "2.5",
                    cy: "2.5",
                    r: "1.2"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "10.5",
                    cy: "2.5",
                    r: "1.2"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "18.5",
                    cy: "2.5",
                    r: "1.2"
                })
            ]
        })
    }));
};
var PlusIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 17 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 17 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 17 17",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.white,
            strokeLinecap: "round",
            strokeWidth: "3",
            children: /*#__PURE__*/ jsx("path", {
                d: "M2 8.5h13M8.5 15V2"
            })
        })
    }));
};
var MinusIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 10 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 10 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 10 10",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            children: /*#__PURE__*/ jsx("path", {
                d: "M1 5h8"
            })
        })
    }));
};
var LeftArrowIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 10 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 7 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 7 10",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M5 1 1 5l4 4",
            fill: "none",
            fillRule: "evenodd",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.8"
        })
    }));
};
var RightArrowIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 10 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 7 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 7 10",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "m2 1 4 4-4 4",
            fill: "none",
            fillRule: "evenodd",
            stroke: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.8"
        })
    }));
};
var NoticeIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 16 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 16 : _props_height, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "height",
        "colorOverride"
    ]);
    var color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.pink;
    var borderColor = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.glass;
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 18 18",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("title", {
                children: "Notice"
            }),
            /*#__PURE__*/ jsx("g", {
                children: /*#__PURE__*/ jsxs("g", {
                    transform: "matrix(1 0 0 -1 0 18)",
                    children: [
                        /*#__PURE__*/ jsx("g", {
                            children: /*#__PURE__*/ jsx("path", {
                                d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16z",
                                fill: "none",
                                stroke: borderColor,
                                strokeMiterlimit: "20"
                            })
                        }),
                        /*#__PURE__*/ jsx("g", {
                            children: /*#__PURE__*/ jsx("path", {
                                d: "M9.92 4.613a1.035 1.035 0 0 0-.543-.536 1.006 1.006 0 0 0-.773 0 1 1 0 0 0-.526.536.992.992 0 0 0-.078.393.995.995 0 0 0 .291.699c.091.09.196.161.313.215a.976.976 0 0 0 .773 0 1.07 1.07 0 0 0 .324-.216 1.01 1.01 0 0 0 .219-.314.93.93 0 0 0 .08-.384c0-.14-.027-.271-.08-.393zM8 7v7h2V7z",
                                fill: color
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
// default size: 12x12
var EditIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 12 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 12 : _props_height, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "height",
        "colorOverride"
    ]);
    var color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night;
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 12 12",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("title", {
                children: "Edit"
            }),
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M0.546875 9.15331V11.2989C0.546875 11.6066 0.796372 11.856 1.1041 11.856H3.24954C3.39739 11.856 3.53908 11.7973 3.64366 11.6929L3.81982 11.5167C4.03734 11.299 4.03734 10.9463 3.81982 10.7286L1.67423 8.58317C1.45671 8.3655 1.10381 8.3655 0.886285 8.58317L0.710126 8.75933C0.605546 8.86377 0.546875 9.00546 0.546875 9.15331Z",
                fill: color,
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M2.40544 7.84999L4.55103 9.99558C4.76855 10.2131 5.12131 10.2131 5.33898 9.99558L11.3052 4.02921C11.8429 3.49149 11.8429 2.61979 11.3052 2.08207L10.3188 1.09567C9.78108 0.557954 8.90938 0.557954 8.37167 1.09567L2.40544 7.06204C2.18777 7.27957 2.18777 7.63232 2.40544 7.84999Z",
                fill: color,
                fillRule: "evenodd"
            })
        ]
    }));
};
// default size: 18x20
var BinIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 18 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 20 : _props_height, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "height",
        "colorOverride"
    ]);
    var color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night;
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        height: height,
        viewBox: "0 0 18 20",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("title", {
                children: "Bin"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M1.501 4.543H16.5M3.568 4.543v11.48a3 3 0 0 0 3 3h4.86a3 3 0 0 0 3-3V4.543M10.81 15.385V8.18M7.193 15.385V8.18M5.638 4.08V2.977a2 2 0 0 1 2-2h2.723a2 2 0 0 1 2 2V4.08",
                stroke: color,
                strokeLinecap: "round",
                strokeWidth: "1.5"
            })
        ]
    }));
};
var FileIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 15 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 19 : _props_height, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "height",
        "colorOverride"
    ]);
    var color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.light;
    var backgroundColor = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.cloud;
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 15 19",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("rect", {
                fill: backgroundColor,
                height: "19",
                rx: "3",
                width: "14.25"
            }),
            /*#__PURE__*/ jsx("rect", {
                fill: color,
                height: "1.32558",
                rx: "0.662791",
                width: "9.33697",
                x: "2.45703",
                y: "5.74414"
            }),
            /*#__PURE__*/ jsx("rect", {
                fill: color,
                height: "1.32558",
                rx: "0.662791",
                width: "9.33697",
                x: "2.45703",
                y: "8.8374"
            }),
            /*#__PURE__*/ jsx("rect", {
                fill: color,
                height: "1.32558",
                rx: "0.662791",
                width: "4.8908",
                x: "2.45703",
                y: "11.9302"
            })
        ]
    }));
};
var InfoIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 18 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 18 : _props_height, colorOverride = props.colorOverride, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 1 : _props_strokeWidth, restProps = _object_without_properties(props, [
        "width",
        "height",
        "colorOverride",
        "strokeWidth"
    ]);
    var color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.night;
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 18 18",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: "9",
                cy: "9",
                r: "7.6",
                stroke: color,
                strokeWidth: strokeWidth
            }),
            /*#__PURE__*/ jsx("path", {
                clipRule: "evenodd",
                d: "M9.96 3.938v3.97c0 .425-.025.848-.075 1.266a19 19 0 0 1-.202 1.281H8.226c-.084-.435-.15-.862-.202-1.28-.05-.42-.076-.842-.076-1.267v-3.97h2.013ZM7.713 12.96a1.152 1.152 0 0 1 .35-.84 1.224 1.224 0 0 1 .872-.347c.17 0 .33.031.479.094.148.062.277.146.388.253a1.149 1.149 0 0 1 .354.84 1.176 1.176 0 0 1-.354.846c-.11.107-.24.19-.388.25a1.26 1.26 0 0 1-.48.09c-.175 0-.337-.03-.485-.09a1.165 1.165 0 0 1-.736-1.097Z",
                fill: color,
                fillRule: "evenodd"
            })
        ]
    }));
};
var PinkVIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 15 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 19 : _props_height, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "height",
        "colorOverride"
    ]);
    var color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.primary;
    return /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 14 15",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: "7",
                cy: "7.5",
                fill: color,
                fillOpacity: "0.06",
                r: "7"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M4.85437 7.68406L6.52989 9.44256L9.44746 6.38049",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5"
            })
        ]
    }));
};
var StarIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 16 : _props_width, _props_height = props.height, height = _props_height === void 0 ? 16 : _props_height, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "height",
        "colorOverride"
    ]);
    var color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.primary;
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 36 32",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M16.0539 1.21821C16.8539 -0.406069 19.146 -0.406072 19.946 1.21821L23.4919 8.41805C23.8161 9.07612 24.4441 9.5268 25.1655 9.61893L33.1691 10.6411C35.0101 10.8762 35.7322 13.185 34.3596 14.4474L28.6288 19.7181C28.0679 20.234 27.8134 21.0081 27.9573 21.7609L29.4135 29.3801C29.7585 31.1853 27.8892 32.5953 26.2759 31.7469L19.0031 27.9225C18.3743 27.5919 17.6256 27.5919 16.9968 27.9225L9.72404 31.7469C8.11067 32.5953 6.24144 31.1853 6.58644 29.3801L8.04262 21.7609C8.18648 21.0081 7.93199 20.234 7.37107 19.7181L1.64033 14.4474C0.267713 13.185 0.989785 10.8762 2.83077 10.6411L10.8344 9.61893C11.5558 9.5268 12.1838 9.07613 12.5079 8.41805L16.0539 1.21821Z",
            fill: color
        })
    }));
};
var RevertIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 12 : _props_width, restProps = _object_without_properties(props, [
        "width"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: "12",
        viewBox: "0 0 12 12",
        width: width
    }, restProps), {
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("path", {
            d: "M2.95498 10.7564H7.63919C8.73218 10.7564 10.9181 10.1007 10.9181 7.4775C10.9181 4.85434 8.73218 4.19855 7.63919 4.19855H1.0813M1.0813 4.19855L3.4234 1.85645M1.0813 4.19855L3.4234 6.54066",
            stroke: theme.colors.metal,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    }));
};
var CountryIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, restProps = _object_without_properties(props, [
        "width"
    ]);
    return /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: "20",
        viewBox: "0 0 20 20",
        width: width
    }, restProps), {
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: "10",
                cy: "10",
                r: "9",
                stroke: theme.colors.night,
                "stroke-width": "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M13.3273 2C10.9637 3.33934 10.2378 6.67184 11.9091 8.25026C13.3273 9.58961 14.2727 8.69671 15.6909 9.14316C17.1091 9.58961 17.1091 11.3754 19 10.9289",
                stroke: theme.colors.night,
                "stroke-width": "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M5.52327 5.52624C5.06695 5.21512 4.44482 5.33284 4.13371 5.78916C3.8226 6.24548 3.94031 6.8676 4.39663 7.17872L5.52327 5.52624ZM6.87518 9.70177C7.1273 9.05429 7.25019 8.30111 7.04382 7.52954C6.83392 6.74478 6.31722 6.06754 5.52327 5.52624L4.39663 7.17872C4.87469 7.50465 5.04852 7.80999 5.11173 8.04631C5.17847 8.29583 5.15704 8.60226 5.01148 8.97607L6.87518 9.70177ZM3.4464 15.9434C4.55732 15.6776 5.3943 15.2814 5.96028 14.6873C6.55328 14.0648 6.73459 13.3471 6.77505 12.6998C6.81022 12.137 6.73418 11.4269 6.7178 10.9979C6.69838 10.4894 6.72883 10.0776 6.87518 9.70177L5.01148 8.97607C4.71743 9.73123 4.69607 10.467 4.71926 11.0742C4.74548 11.7609 4.80648 12.1345 4.77894 12.575C4.75669 12.9311 4.67555 13.1363 4.51219 13.3078C4.32181 13.5076 3.90852 13.7764 2.9811 13.9983L3.4464 15.9434Z",
                fill: theme.colors.night
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M8.99563 14.2719C8.99563 14.2719 8.85617 13.2659 9.45272 12.4436C10.5 11 12.0429 11.6717 12.5 13.5C12.7286 14.4144 12.2991 15.4435 11.132 15.6204",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-width": "2"
            })
        ]
    }));
};
var CityIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, restProps = _object_without_properties(props, [
        "width"
    ]);
    return /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
        fill: "none",
        viewBox: "0 0 20 20",
        width: width
    }, restProps), {
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M12 19H1.5C1.22386 19 1 18.7761 1 18.5V2.5C1 2.22386 1.22386 2 1.5 2H11.5C11.7761 2 12 2.22386 12 2.5V15.5",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-width": "2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M12 19H18.5C18.7761 19 19 18.7761 19 18.5V6.5C19 6.22386 18.7761 6 18.5 6H14.5",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-width": "2"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "15",
                y: "10"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "15",
                y: "14"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "4",
                y: "10"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "4",
                y: "6"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "4",
                y: "14"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "8",
                y: "10"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "8",
                y: "6"
            }),
            /*#__PURE__*/ jsx("rect", {
                height: "1",
                stroke: theme.colors.night,
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                width: "1",
                x: "8",
                y: "14"
            })
        ]
    }));
};
var PhoneSolidIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        fill: "none",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/ jsx("path", {
            "clip-rule": "evenodd",
            d: "M3.71705 9.24783C5.32705 10.8578 7.10705 11.9878 8.93705 12.3578C11.687 12.9078 13.257 9.99783 12.027 8.52783C10.827 7.08783 8.44705 5.68783 7.36705 7.74783C7.27705 7.90783 6.89705 8.81783 5.53705 7.44783C4.17705 6.08783 5.06705 5.69783 5.23705 5.61783C7.29705 4.53783 5.88705 2.14783 4.44705 0.937829C2.96705 -0.292171 0.0670464 1.27783 0.617046 4.03783C0.987046 5.84783 2.12705 7.65783 3.72705 9.25783L3.71705 9.24783Z",
            fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.white,
            "fill-rule": "evenodd"
        })
    }));
};
var EnvelopeSolidIcon = function(props) {
    var theme = useTheme();
    var _props_width = props.width, width = _props_width === void 0 ? 20 : _props_width, colorOverride = props.colorOverride, restProps = _object_without_properties(props, [
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        fill: "none",
        viewBox: "0 0 13 13",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M1.87205 1.85449C1.36225 1.85449 0.948975 2.26777 0.948975 2.77757V3.35996C0.948975 3.39983 0.972652 3.43588 1.00923 3.45173L6.65631 5.8974C6.91401 6.009 7.20676 6.00711 7.46299 5.89217L12.8899 3.45795C12.9258 3.44183 12.949 3.40611 12.949 3.36671V2.77757C12.949 2.26777 12.5357 1.85449 12.0259 1.85449H1.87205Z",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.white
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M12.949 5.00161C12.949 4.92844 12.873 4.88005 12.8067 4.911L7.47742 7.39923C7.21298 7.5227 6.9078 7.52448 6.64194 7.40412L1.09022 4.89076C1.02402 4.86079 0.948975 4.9092 0.948975 4.98186V10.1622C0.948975 10.672 1.36225 11.0853 1.87205 11.0853H12.0259C12.5357 11.0853 12.949 10.672 12.949 10.1622V5.00161Z",
                fill: colorOverride !== null && colorOverride !== void 0 ? colorOverride : theme.colors.white
            })
        ]
    }));
};
var CopyIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 16 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 16 : _props_width, _props_colorOverride = props.colorOverride, colorOverride = _props_colorOverride === void 0 ? theme.colors.metal : _props_colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsxs(Svg, _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 16 16",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: [
            /*#__PURE__*/ jsx("rect", {
                height: "11.1034",
                rx: "2",
                stroke: colorOverride,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                width: "9.65517",
                x: "4.89655",
                y: "3.89655"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M4.06235 12.1034H3.93103C2.86455 12.1034 2 11.2389 2 10.1724V2.93103C2 1.86455 2.86455 1 3.93103 1H9.72414C10.7906 1 11.6552 1.86455 11.6552 2.93103V3.89655",
                stroke: colorOverride,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5"
            })
        ]
    }));
};
var InvertedCircledCheckmarkIcon = function(props) {
    var theme = useTheme();
    var _props_height = props.height, height = _props_height === void 0 ? 17 : _props_height, _props_width = props.width, width = _props_width === void 0 ? 17 : _props_width, _props_colorOverride = props.colorOverride, colorOverride = _props_colorOverride === void 0 ? theme.colors.metal : _props_colorOverride, restProps = _object_without_properties(props, [
        "height",
        "width",
        "colorOverride"
    ]);
    return /*#__PURE__*/ jsx("svg", _object_spread_props(_object_spread({
        fill: "none",
        height: height,
        viewBox: "0 0 17 17",
        width: width,
        xmlns: "http://www.w3.org/2000/svg"
    }, restProps), {
        children: /*#__PURE__*/ jsxs("g", {
            id: "Check",
            children: [
                /*#__PURE__*/ jsx("circle", {
                    cx: "8.5",
                    cy: "8.5",
                    fill: colorOverride,
                    fillOpacity: "0.06",
                    id: "Ellipse 6",
                    r: "8.5"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M5.89453 8.72353L7.92909 10.8588L11.4719 7.14062",
                    id: "Path 2 Copy 2",
                    stroke: colorOverride,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "1.8"
                })
            ]
        })
    }));
};

export { BackIcon, BinIcon, BottomLargeArrowIcon, BottomSmallArrowIcon, CakeIcon, CalendarIcon, CheckmarkIcon, CircledCheckmarkIcon, CircledPinkCheckmarkIcon, CityIcon, CloseIcon, CopyIcon, CountryIcon, CreditCardIcon, DeleteIcon, DownloadIcon, EditIcon, EnvelopeIcon, EnvelopeSolidIcon, FatSmallBottomChevronIcon, FatSmallLeftChevronIcon, FileIcon, HamburgerIcon, HelpIcon, InfoIcon, InvertedCircledCheckmarkIcon, LeftArrowIcon, LocationIcon, LockIcon, MinusIcon, MoreIcon, NonPrivateIcon, NoticeIcon, PhoneIcon, PhoneSolidIcon, PinkVIcon, PlusIcon, PrivateIcon, RefreshIcon, RevertIcon, RightArrowIcon, SearchIcon, StarIcon, ThinBigLeftChevronIcon, ThinBigRightChevronIcon, ThinSmallLeftChevronIcon };
